import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'
import validator from 'validator'
import { capitalize } from '../../../utils/helpers'
//Components
import Title from '../../step/title/title'
import SubTitle from '../../step/title/subtitle'

import Input from '../../step/input/input'
import Button from '../../step/button/button'
import InfoTag from '../../step/infotag/infotag'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  ${media.md`
    flex-direction: row; 
    margin-top: 40px;
`};
`

class StepName extends React.Component {
  state = {
    isError: false
  }

  _onNextPress = () => {
    const { name, nextStep, updateName, updateRUC, ruc } = this.props
    if (validator.isEmpty(name.trim())) {
      updateName('')
      this.setState({ isError: true })
    } else if (validator.isEmpty(ruc.trim())) {
      updateRUC('')
      this.setState({ isError: true })
    } else {
      if (this.validarRucPersonaNatural(ruc)) {
        nextStep()
      } else {
        this.setState({ isError: true })
      }
    }
  }

  _onChangeInput = event => {
    const { updateName } = this.props
    updateName(capitalize(event.target.value))
  }

  _onChangeRUC = event => {
    const { updateRUC } = this.props
    updateRUC(event.target.value)
  }

  _keyPressEnter = event => {
    if (event.key === 'Enter') {
      this._onNextPress()
    }
  }

  validarRucPersonaNatural(numero) {
    let result = this.validarInicial(numero, '13')
    result = this.validarCodigoProvincia(numero.substr(0, 2))
    result = this.validarTercerDigito(numero[2], 'ruc_natural')
    result = this.validarCodigoEstablecimiento(numero.substr(10, 3))
    return result
  }

  validarInicial(numero, caracteres) {
    if (numero == '' || numero == undefined) {
      return false
    }

    if (!validator.isNumeric(numero.trim())) {
      return false
    }

    if (numero.length != caracteres) {
      return false
    }
    return true
  }

  validarCodigoProvincia(numero) {
    if (numero < 0 || numero > 24) {
      return false
    }
    return true
  }

  validarTercerDigito(numero) {
    if (numero < 0 || numero > 5) {
      return false
    }
    return true
  }
  validarCodigoEstablecimiento(numero) {
    if (numero < 1) {
      return false
    }
    return true
  }

  render() {
    const { isError } = this.state
    const { currentStep, name, ruc } = this.props
    return 1 != currentStep ? null : (
      <div className="col-md-8 " style={{ margin: 'auto' }}>
        <div>
          <Title title="Cual es el nombre de tu empresa " />
          <Input
            value={name}
            onChange={this._onChangeInput}
            placeholder="Nombre"
            onKeyPress={this._keyPressEnter}
          />
        </div>
        <div>
          <div>
            <Title title="¿Cual es el número de RUC? " />
            <Input
              value={ruc}
              onChange={this._onChangeRUC}
              placeholder="Número"
              onKeyPress={this._keyPressEnter}
            />
            <Wrapper>
              <div>
                <Button onClick={this._onNextPress} title="Siguiente" />
                <SubTitle title="O presione ENTER" />
              </div>
              {isError ? (
                <InfoTag message="&times; No te preocupes, no revelaremos tu identidad" />
              ) : null}
            </Wrapper>
          </div>
        </div>
      </div>
    )
  }
}

export default StepName



// WEBPACK FOOTER //
// ./src/components/contactus/steps/StepName.js